import { CombinedDatepickerRangeOutput, ListRange, SearchCriteriaBase } from '../../../../../common/models';
import { ListQueryParam } from '../../../../../common/constants/list-query-param.constant';
import { DataQualityErrorMessage } from '../../message-checker';

export class Sc3FailedMessagesModel {
  transactionNumber: string;
  transactionDateTime: number;
  carrierId: string;
  toNumber: string;
  loadNumber: string;
  rawMessageId: number;
  errors: DataQualityErrorMessage;
}

export class Sc3FailedMessagesListSearchCriteria extends SearchCriteriaBase {
  [ListQueryParam.TransactionDateTime]: CombinedDatepickerRangeOutput;
  [ListQueryParam.CarrierId]: string[];
  [ListQueryParam.TransportReferences]: string[];

  constructor(params?: Partial<Sc3FailedMessagesListSearchCriteria> | ListRange) {
    super();
    if (params) {
      Object.assign(this, params);
    }
  }
}
